import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import * as Sentry from '@sentry/angular';

/**
 * Collects X-Attq-Request-Id from all HTTP responses and handles errors
 * On error:
 * 1. Sends to Sentry with request context
 * 2. Displays error to user with request ID for support tracking
 */
@Injectable({
  providedIn: 'root'
})
export class RequestIdInterceptor implements HttpInterceptor {
  static lastRequestId: string | null = null;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        next: (event: any) => this.attachRequestContext(request, event),
        error: (event: any) => this.attachRequestContext(request, event)
      })
    );
  }

  private attachRequestContext(request: HttpRequest<any>, event: any): void {
    const requestId = event?.headers?.get?.('x-attq-request-id') ?? null;

    if (!requestId) {
      // Clean it up to prevent leaks between requests
      Sentry.setTag('attq_request.id', null);
      Sentry.setContext('attq_request', null);
      return;
    }

    // Store in static property for error handler to access
    RequestIdInterceptor.lastRequestId = requestId;

    // Store in Sentry breadcrumbs context for error tracking
    Sentry.setTag('attq_request.id', requestId);
    Sentry.setContext('attq_request', {
      id: requestId,
      url: request.url,
      method: request.method
    });
  }
}
